// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    config_id_portal: 4,
    url_favicons: 'ico_pri',
    config_url_json_portal: 'https://devged.mdt.mx/api/Portal/curso',// Url para peticion del json del curso; payload = { "id":4 }
    url_efemerides: 'https://www.krismar-educa.com.mx/Efemerides/',// URL base para las efemérides
    url_catalogos: 'https://krismarutils.mdt.mx/public/Catalogos/',// URL base para los catálogos
    url_img_favicon: 'assets/redi/img/web_redi_pri_favicon.png',// URL base para el favicon
    url_img_app: 'https://krismarapps.mdt.mx/src/img/miniatura/',// URL base para las imágenes de la aplicación
    url_get_app: "https://krismarapps.mdt.mx/index.php/recurso/cargarApp/",//URL que solicita la aplicación

    paleta_colores: 'assets/redi/css/acentoColorPrimaria.css',//nombre del archivo que contiene la paleta de colores del proyecto
    carrucel_texto: 'PRIMARIA',// Texto que se muestra en el carrusel
    carrucel_ruta_img: 'assets/redi/img/portal_primaria_interfaz_img_',// Ruta base para las imágenes del carrusel
    carrucel_n_img: 7, // numero de imagenes que se muestran en el carrucel

    // parametros para el componente de asignaturas
    asignaturas_label: "Asignaturas",// Etiqueta que se muestra en el componente de asignaturas
    asignaturas_list: [
        {
            label: 'Atlas',
            clase: 'd_asig_atl'
        },
        {
            label: 'Ciencias naturales',
            clase: 'd_asig_nat'
        },
        {
            label: 'Comprensión lectora',
            clase: 'd_asig_lec'
        },
        {
            label: 'Desafíos matemáticos',
            clase: 'd_asig_pec'
        },
        {
            label: 'Educación artística',
            clase: 'd_asig_art'
        },
        {
            label: 'Educación física',
            clase: 'd_asig_efi'
        },
        {
            label: 'Español',
            clase: 'd_asig_lyc'
        },
        {
            label: 'Formación cívica y ética',
            clase: 'd_asig_cyc'
        },
        {
            label: 'Geografía',
            clase: 'd_asig_geo'
        },
        {
            label: 'Historia',
            clase: 'd_asig_his'
        },
        {
            label: 'Matemáticas',
            clase: 'd_asig_pmt'
        }
    ],

    // parametros para el componente de grados
    grados_label: "Grados",// Etiqueta que se muestra en el componente de grados

    grados_list: [
        { label: '1°', clase: 'd_grad_pri_1 d_inactiveicons', title: 'Primer Grado' },
        { label: '2°', clase: 'd_grad_pri_2 d_inactiveicons', title: 'Segundo Grado' },
        { label: '3°', clase: 'd_grad_pri_3 d_inactiveicons', title: 'Tercer Grado' },
        { label: '4°', clase: 'd_grad_pri_4 d_inactiveicons', title: 'Cuarto Grado' },
        { label: '5°', clase: 'd_grad_pri_5 d_inactiveicons', title: 'Quinto Grado' },
        { label: '6°', clase: 'd_grad_pri_6 d_inactiveicons', title: 'Sexto Grado' },
    ]
    , portal: 'primaria',
    title_html: 'ReDi Primaria - Krismar',

    url_serve_api_auth: 'https://devnem.mdt.mx/api/',//Url para peticion del json del curso; payload = { "id":4 }
    codeAdmin: '',//Codigo de administrador
    offline: false,//Indica si se esta en modo offline y toma los grados permitidos de la variable gradosPermitidos
    gradosPermitidos: ["N37", "N38", "N39", "N40", "N41", "N42"],//codigos de grados permitidos
    equivalencias: {
        "N37": 30,//'1°'
        "N38": 31,//'2°'
        "N39": 32,//'3°'
        "N40": 33,//'4°'
        "N41": 34,//'5°'
        "N42": 35,//'6°'
    },// equivalencias de codigos con el id del grado en la base de datos
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
